import { type IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { Icon } from "@b2bportal/core-ui";
import styles from "./styles.module.scss";

interface NavigationItemProps {
  title: string;
  link: string;
  onClick: (link: string) => void;
  isExternalLink?: boolean;
  icon?: IconNameEnum;
}

export const NavigationItem: React.FC<NavigationItemProps> = ({
  icon,
  title,
  link,
  onClick,
}) => {
  const [block, cn] = useModuleBEM(styles, "NavigationItem");

  return (
    <li>
      <button onClick={() => onClick(link)} className={block}>
        {icon != null && (
          <Icon
            className={cn("list-icon")}
            iconName={icon}
            aria-hidden="true"
          />
        )}
        <span>{title}</span>
      </button>
    </li>
  );
};
